import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import EasyRoute from '@billow/easy-route' 
import auth from '@/router/guards/auth'
import guest from '@/router/guards/guest'
import VueBulma from '@billow/vue-bulma' 
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { filters } from '@billow/js-helpers'
import * as ModalDialogs from 'vue-modal-dialogs'
import EventBus from '@/utilities/event-bus'
import './views/scrapers/install'
import './views/attribute-type/secondary-scrapers/builder-inputs/install'
library.add(fas, far, fab)
dom.watch()

Vue.config.productionTip = process.env.VUE_APP_DEBUG

import Toast from '@billow/toast'

Vue.use(Toast, {
  types: Toast.types,
  namespaced: true
})

Vue.use(ModalDialogs)
Vue.use(filters)
Vue.use(EasyRoute, {
  router,

  guards: [
    auth,
    guest
  ]
})
Vue.use(VueBulma, { store })

Vue.component('nav-link', () => import('@/layout/Link'))
Vue.component('heading', () => import('@/layout/typography/Heading'))
Vue.component('columns', () => import('@/layout/grid/Columns'))
Vue.component('column', () => import('@/layout/grid/Column'))
Vue.component('box', () => import('@/layout/Box'))
Vue.component('name-input', () => import('@/layout/forms/common/NameInput'))
Vue.component('save-button', () => import('@/layout/buttons/SaveButton'))
Vue.component('loader', () => import('@/components/Loader'))
Vue.component('markdown', () => import('vue-markdown-it'))
Vue.component('route-assessment-builder', () => import('@/views/assessors/partials/RouteBuilder.vue'))
Vue.component('attribute-assessment-builder', () => import('@/views/assessors/partials/AttributeBuilder.vue'))
Vue.component('source-lookup-grammar', () => import('@/components/scraper/SourceLookupGrammar.vue'))
Vue.component('child-source-grammar', () => import('@/components/scraper/ChildSourceGrammar.vue'))
Vue.component('raw-scrape-type', () => import('@/components/scraper/RawScrapeType.vue'))

Vue.prototype.$pageLoading = (value) => {
  store.commit('global/loadingPage', value)
}

Vue.prototype.$bus = EventBus

Promise.all([
  store.dispatch('auth/loadUser'),
]).then(() => {
  let user = store.getters['auth/user']
}).finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  
    computed: {
      errors() {
        return store.getters['global/errors']
      },
      errorBag() {
        return this.errors.errors
      }
    }
  }).$mount('#app')
})
